import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";
import { isValidEmail } from "../../../utils/Utils";
import MyLabel from "./MyLabel";

const MyEmail = ({
  title,
  name,
  register,
  watch,
  trigger,
  errors,
  setValue,
  placeholder,
  required,
  min,
  max,
  disabled,
}) => {
  return (
    <div className="form-group">
      <MyLabel name={name} title={title} required={required} />
      <div className="form-control-wrap">
        <input
          placeholder={"Enter email address"}
          type="text"
          id="email"
          // {...register("email", {
          //   required: {
          //     value: required,
          //     message: "Email address is required",
          //   },
          //   validate: {
          //     isValid: (value) => isValidEmail(value) || "Enter valid email address",
          //   },
          // })}
          {...register("email", {
            required: {
              value: required,
              message: "Email address is required",
            },
            validate: {
              isValid: (value) => {
                if (!value) return true; // ✅ allow empty when not required
                return isValidEmail(value) || "Enter valid email address";
              },
            },
          })}
          className={`form-control ${errors?.[name] ? "is-invalid" : ""}`}
          value={watch("email")}
          onChange={(e) => {
            setValue("email", e.target.value);
            trigger("email");
          }}
          disabled={disabled}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default MyEmail;
